import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IConsultarDosisFaltanteDTO } from '../../domain/interfaces/novedad/programacion/Iconsultar-dosis-faltanteDTO';
import { ProfesionalResponseModel } from '../../domain/model/maestro/entity/ProfesionalResponse.model';
import { Profesional } from '../../domain/model/programacion/entity/profesional.model';
import { FiltrosCita } from '../request-model/novedad/filtros-cita.request';
import { NotificacionEnlacePagerRequest } from '../request-model/pager/notificacion-enlace-pager.request';
import { NotificacionRecordatorioPagerRequest } from '../request-model/pager/notificacion-recordatorio-pager.request';


@Injectable({
  providedIn: 'root'
})
export class ProgramacionService {


  private readonly url: string;
  private readonly port: string;

  constructor(private readonly http: HttpClient) {
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;
  }

  public getProgramacion(idRemision: string, estados?: string[]): Observable<any> {
    let params = '';
    if (estados && estados.length > 0) {
      params = `?estados=${estados.join(',')}`;
    }
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarProgramacion/${idRemision}${params}`;
    return this.http.get<any>(URL, { withCredentials: true });
  }

  public getProgramacionEspecialidad(idRemision: string, especialidad: string, estados?: string[]): Observable<any> {
    let params = '';
    if (estados && estados.length > 0) {
      params = `?estados=${estados.join(',')}`;
    }
    console.log("Especialidad: ", especialidad);
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarProgramacionEspecialidad/${idRemision}${especialidad}${params}`;
    return this.http.get<any>(URL, { withCredentials: true }).pipe();
  }

  public getProgramacionCuidador(idRemision: string, idTratamiento: string): Observable<any> {
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarCitasCuidador/${idRemision}/${idTratamiento}`;;
    return this.http.get<any>(URL, { withCredentials: true }).pipe();
  }

  public guardarRemision(data: any): Observable<any> {
    const URL = `${this.url}${this.port}/api_programacion/novedad/consultarDisponibilidad`;
    return this.http.post<any>(URL, data, { withCredentials: true }).pipe();
  }

  public consultarEstadoCitas(): Observable<any> {
    const URL = `${this.url}${this.port}/api_programacion/lineaUnica/consultarEstadosCita`;;
    return this.http.get<any>(URL, { withCredentials: true }).pipe();
  }

  public consultarCitas(ciudad: string | null, programa: string, tipoIdentificacion: string, numeroIdentificacion: string, remision: string[],
    especialidad: string, idEstadoCita: number, fechaInicio: string | null, fechaFin: string | null, page: number, size: number): Observable<any> {

    const FILTROS = new FiltrosCita(ciudad, programa, tipoIdentificacion, numeroIdentificacion, remision, especialidad, idEstadoCita,
      fechaInicio, fechaFin, page, size
    );

    const URL = `${this.url}${this.port}/api_programacion/lineaUnica/consultarCitas`;
    const parametros = this.getHttpParams(FILTROS);
    return this.http.get<any>(URL, { params: parametros, withCredentials: true }).pipe();
  }

  private getHttpParams(params: FiltrosCita): HttpParams {
    let httpParams: HttpParams = new HttpParams();
    Object.entries(params).forEach(value => {
      if (value[1]) {
        httpParams = httpParams.append(value[0], value[1]);
      }
    });
    return httpParams;
  }

  public consultarProfesionalPorDocumento(idProfesional: any) {
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarProfesionalPorId/${idProfesional}`;
    return this.http.get<Profesional>(URL, { withCredentials: true })
      .toPromise()
      .then(res => res)
      .then(data => { return data.nombreCompleto; });
  }

  public consultarDosisFaltantes(idRemision: string): Observable<IConsultarDosisFaltanteDTO> {
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarDosisFaltantes/${idRemision}`;
    return this.http.get<any>(URL, { withCredentials: true }).pipe();
  }

  public notificacionUnicaPager(recordatorioRequest: NotificacionRecordatorioPagerRequest): Observable<any> {
    const URL = `${this.url}${this.port}/api_programacion/notificacionUnicaPager`;
    return this.http.post(URL, recordatorioRequest, { responseType: 'text', withCredentials: true }).pipe();
  }

  public enlaceUnicoPager(enlaceRequest: NotificacionEnlacePagerRequest): Observable<any> {
    const URL = `${this.url}${this.port}/api_programacion/enlaceUnicoPager`;
    return this.http.post(URL, enlaceRequest, { responseType: 'text', withCredentials: true }).pipe();
  }

  consultarProfesionalesActivos(especialidad: string, nombreCiudad: string): Observable<ProfesionalResponseModel[]> {
    const URL = `${this.url}${this.port}/api_programacion/programacion/consultarProfesionalesDisponibles`;
    const params = new HttpParams().set('especialidad', especialidad).set('nombreCiudad', nombreCiudad);
    return this.http.get<ProfesionalResponseModel[]>(URL, { params, withCredentials: true }).pipe();

  }

}
